import { useCallback } from "react";
// import Image from "../../atoms/image/image";
import Image from 'next/image';
import styles from "./UpgradeModal.module.scss";
import config from "../../../config/index";
import Checkbox from "../../atoms/checkBox/Checkbox";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import {
  Modal,
  Form,
  Row,
  connect,
  CustomContainer,
} from "../../atoms/DependencyHelper";
import OTPInput from "../otpInput/OtpInput";
import { componentCheckSize } from "../../../utils/helperServices";
import UpgradeDropdown from "../../atoms/upgradeDropdown/UpgradeDropdown";
import { updatedNextMsisdnSelected } from "../../../Redux/actions/upgradeAction";
import labels from "../../../config/labels";
import IconsComponent from "../../atoms/iconsComponent/IconsComponent";

const UpgradeComponent = ({
                            displayData,
                            showModal,
                            toggleModal,
                            updatedNextMsisdnSelected
                          }) => {
  const {
    iconUrl,
    title,
    description,
    infoText,
    mobileNumbers,
    numbers,
    selectedNumber,
    handleOptionClick,
    input,
    inputTitle,
    onChangeHandler,
    onBlurHandler,
    errorMessage,
    maxLength,
    checkbox,
    checkValue,
    checkBoxHandler,
    checkBoxText,
    checkDatabox,
    checkDataValue,
    checkBoxDataHandler,
    checkBoxData,
    otpInput,
    otpValue,
    otpHandler,
    primaryButtonText,
    primaryButtonStyle,
    primaryButtonDisabled,
    onClickHandlerPrimary,
    secondaryButtonText,
    secondaryButtonStyle,
    secondaryButtonDisabled,
    onClickHandlerSecondary,
    textButton,
    textButtonHandler,
    dropdown,
    dropdownData,
    selectedDropdownValue,
    handleVal,
    showAddnlInfo,
    invalidOTPTries,
  } = displayData;
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const isMobile = componentCheckSize() <= 768;
  const callbackRef = useCallback((inputFocus) => {
    setTimeout(() => {
      if (inputFocus) {
        inputFocus.focus();
      }
    }, [300]);
  }, []);
  const primaryButtonClass =
      primaryButtonText && primaryButtonText.toLowerCase() == "continue"
          ? "upgrade-btn-continue"
          : primaryButtonText && primaryButtonText.toLowerCase() == "submit otp"
              ? "upgrade-btn-submit-otp"
              : "upgrade-continue";
  const modalContentClass =
      !isMobile &&
      primaryButtonText &&
      primaryButtonText.toLowerCase() == "continue"
          ? "upgrade-modal-continue"
          : !isMobile &&
          primaryButtonText &&
          primaryButtonText.toLowerCase() == "submit otp"
              ? "upgrade-modal-submit-otp"
              : "upgrade-modal";
  const isSubmitOTP =
      primaryButtonText && primaryButtonText.toLowerCase() == "submit otp"
          ? true
          : false;
  let descriptionMarginClassName = "";
  if (input || (primaryButtonText && secondaryButtonText)) {
    descriptionMarginClassName = styles["medium-margin-bottom"];
  }
  if (dropdown && !infoText) {
    descriptionMarginClassName = styles["big-margin-bottom"];
  }

  const scrollToTop = () => {
    // scrolling the window up when closing the modal
    if (showModal) window.scrollTo(0, 0);
  };

  const primaryButtonClick = () => {
    //updatedNextMsisdnSelected(true); keep this code, will remove or used in next pr
    scrollToTop();
    onClickHandlerPrimary();
  };

  const textButtonClick = () => {
    scrollToTop();
    textButtonHandler();
  };

  const toggleUpgradeModal = () => {
    scrollToTop();
    toggleModal();
  };

  return (
      showModal && (
          <Modal
              show={showModal}
              dialogClassName={`${styles[modalContentClass]}`}
              onHide={toggleUpgradeModal}
              centered
              backdrop="static"
          >
            <Modal.Header className={styles["upgrademodal-header"]}>
              <CustomContainer onClick={toggleUpgradeModal} className={styles["close-button"]}>
                <IconsComponent type="closeBlack" />
              </CustomContainer>
            </Modal.Header>
            <Modal.Body className={styles["modal-body"]}>
              <div className={styles["upgradeComponent"]}>
                {dropdown && (
                    <div className={styles["dropdownContainer"]}>
                      <UpgradeDropdown
                          selectedValue={selectedDropdownValue}
                          optionsList={dropdownData}
                          handleSelect={handleVal}
                      />
                    </div>
                )}
                {showAddnlInfo && (
                    <div className={styles.addnlInfo}>
                      <img
                          src={`${imagePrefix}/assets/images/warning-white.svg`}
                          width={20}
                          height={20}
                      />
                      <div>{labels.upgrade.lbl_addnl_info}</div>
                    </div>
                )}
                {iconUrl && (
                    <img src={`${iconUrl}`} className={styles["icon"]}  alt={''} width={80} height={80} />
                )}
                {title && <div className={styles.title}>{title}</div>}
                {description && (
                    <div
                        className={`${styles.description} ${descriptionMarginClassName}`}
                        dangerouslySetInnerHTML={{
                          __html: description,
                        }}
                    />
                )}
                {infoText && <div className={styles.infoText}>{infoText}</div>}
                {input && (
                    <div className={styles.inputContainer}>
                      <div className={styles.inputTitle}>{inputTitle}</div>
                      <input
                          type="text"
                          ref={callbackRef}
                          placeholder="Enter your cellphone number"
                          className={`${styles["input-box"]} ${
                              errorMessage ? styles["invalid"] : ""
                          }`}
                          onChange={onChangeHandler}
                          onBlur={onBlurHandler}
                          maxLength={maxLength}
                      />
                      {errorMessage && (
                          <div className={styles["invalid-feedback"]}>
                            {errorMessage}
                          </div>
                      )}
                      {checkbox && (
                          <div className={styles.checkboxContainer}>
                            <Checkbox
                                isChecked={!!checkValue}
                                id="checkbox1"
                                click={checkBoxHandler}
                            />
                            <div className={styles["checkboxText"]}>
                              {" "}
                              {checkBoxText}
                            </div>
                          </div>
                      )}
                    </div>
                )}
                {checkDatabox && (
                    <div className={styles.checkboxContainer}>
                      <Checkbox
                          isChecked={!!checkDataValue}
                          id="checkbox2"
                          click={checkBoxDataHandler}
                      />
                      <div className={styles["checkboxText"]}> {checkBoxData}</div>
                    </div>
                )}
                {otpInput && (
                    <OTPInput
                        autoFocus
                        isNumberInput
                        length={4}
                        className={styles["otpContainer"]}
                        inputClassName={styles["otpInput"]}
                        // onChangeOTP={otpHandler}
                        otpValues={otpValue}
                        setOTPValues={otpHandler}
                    />
                )}
                {mobileNumbers && (
                    <Form className={`${styles["select-number-form"]}`}>
                      {(() => {
                        switch (true) {
                          case numbers.length > 4:
                            var multipleNum = [];
                          {
                            numbers.map((item, index) =>
                                multipleNum.push({
                                  id: index,
                                  label: item,
                                })
                            );
                          }
                            return (
                                <Form.Group>
                                  <UpgradeDropdown
                                      selectedValue={selectedNumber}
                                      optionsList={multipleNum}
                                      handleSelect={handleOptionClick}
                                  />
                                </Form.Group>
                            );
                          case numbers.length === 2 || numbers.length === 3:
                            return (
                                <Row className={`justify-content-center mt-3`}>
                                  <ul>
                                    {numbers.map((item, index) => (
                                        <li
                                            key={index}
                                            className={"num-3"}
                                            className={`${styles.singleNumber} ${
                                                selectedNumber === item &&
                                                styles["selctedNumber"]
                                            }`}
                                            onClick={() => handleOptionClick(item)}
                                        >
                                          {item}
                                        </li>
                                    ))}
                                  </ul>
                                </Row>
                            );
                          case numbers.length === 4:
                            return (
                                <Row className={`mt-3 justify-content-center`}>
                                  <ul className={styles["wrap-numbers"]}>
                                    {numbers.map((item, index) => (
                                        <li
                                            key={index}
                                            className={`${styles["num-4"]} ${
                                                styles.singleNumber
                                            } ${
                                                selectedNumber === item &&
                                                styles["selctedNumber"]
                                            }`}
                                            onClick={() => handleOptionClick(item)}
                                        >
                                          {item}
                                        </li>
                                    ))}
                                  </ul>
                                </Row>
                            );
                          default:
                            return (
                                <Row className={`justify-content-center mt-3`}>
                                  <ul>
                                    {numbers.map((item, index) => (
                                        <li
                                            key={index}
                                            className={"num-3"}
                                            className={`${styles.singleNumber} ${
                                                selectedNumber === item &&
                                                styles["selctedNumber"]
                                            }`}
                                            onClick={() => handleOptionClick(item)}
                                        >
                                          {item}
                                        </li>
                                    ))}
                                  </ul>
                                </Row>
                            );
                        }
                      })()}
                    </Form>
                )}
                {textButton && (
                    <CTAButton
                        handleClick={textButtonClick}
                        variant={"flat teal51"}
                        className={styles["re-send-otp-btn"]}
                    >
                      {textButton}
                    </CTAButton>
                )}
                {primaryButtonText && (
                    <div
                        className={
                          isSubmitOTP
                              ? styles.buttonContainerOTP
                              : styles.buttonContainer
                        }
                    >
                      {primaryButtonText && (
                          <CTAButton
                              variant={primaryButtonStyle}
                              className={`${styles[primaryButtonClass]} button-red button-large`}
                              handleClick={primaryButtonClick}
                              disabled={!!primaryButtonDisabled}
                          >
                            {primaryButtonText}
                          </CTAButton>
                      )}
                      {secondaryButtonText && (
                          <CTAButton
                              variant={secondaryButtonStyle}
                              className={`${styles["upgrade-continue"]} button-outline button-large`}
                              handleClick={onClickHandlerSecondary}
                              disabled={secondaryButtonDisabled}
                          >
                            {secondaryButtonText}
                          </CTAButton>
                      )}
                    </div>
                )}
              </div>
            </Modal.Body>
          </Modal>
      )
  );
};

export default connect(null, {
  updatedNextMsisdnSelected,
})(UpgradeComponent);
